import React from 'react'

const Profile1 = () => {
    return (
        <div className='profile'>
             <div className='name_me'>Hi! I am Rathna</div>
            <div className='desc'> <p>I believe professional design makes your business<br/> more <b>attractive.</b> Let me do it!</p></div>
        </div>
    )
}

export default Profile1
